import { render, staticRenderFns } from "./CourseDesignGoods.vue?vue&type=template&id=5def5732&scoped=true&"
import script from "./CourseDesignGoods.vue?vue&type=script&lang=js&"
export * from "./CourseDesignGoods.vue?vue&type=script&lang=js&"
import style0 from "./CourseDesignGoods.vue?vue&type=style&index=0&id=5def5732&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5def5732",
  null
  
)

export default component.exports